var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnAppstoreSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 14.222,
    viewBox: "0 0 58 14.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-2",
    width: 9.889,
    height: 10.104,
    x: 6.54,
    y: 1.778
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 14.222,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M3 0h52.00000373c1.65574507 0 3 1.34425493 3 3v8.22222135c0 1.65574508-1.34425493 3-3 3H3c-1.65574507 0-3-1.34425492-3-3V3c0-1.65574507 1.34425493-3 3-3z"
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.273,
    y: 11.092,
    fill: "rgb(255,255,255)",
    fontFamily: "Montserrat SemiBold",
    fontSize: 6,
    fontWeight: 600,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    }
  }, "App Store")), /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.882,
    y: 4.833,
    fill: "rgb(255,255,255)",
    fontFamily: "Montserrat Medium",
    fontSize: 3,
    fontWeight: 500,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    }
  }, "Cons\xEDguelo en el"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.889,
    height: 10.104,
    x: 6.54,
    y: 1.778,
    fill: "none",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M15.61700107 9.18518462c-.087.17777777-.14500001.38518517-.23200002.56296293-.26100001.59259256-.63800004 1.12592586-1.07300007 1.62962953-.203.2074074-.43500002.38518516-.72500004.44444442-.23200002.05925926-.46400003.02962963-.69600005-.02962963l-.52200003-.17777776c-.52200003-.2074074-1.04400007-.17777777-1.5370001.02962962-.20300001.08888889-.40600003.14814814-.63800004.2074074-.31900002.05925925-.60900004 0-.87000006-.2074074-.23200001-.17777776-.43500002-.38518516-.60900004-.62222218-.49300003-.62222218-.87000005-1.30370362-1.10200007-2.07407395-.20300001-.62222218-.29000002-1.24444437-.26100001-1.89629618.029-.68148144.20300001-1.30370362.63800004-1.83703692s.95700006-.85925921 1.6240001-.9481481c.31900002-.02962962.60900004 0 .89900006.11851852.23200001.08888888.46400003.17777776.72500005.23703702.058.02962963.145.02962963.203.05925926.08700001.02962962.20300002 0 .29000003-.02962963.26100001-.08888889.52200003-.17777777.75400005-.26666665.29000002-.08888889.58000003-.17777777.89900005-.17777777.55100004.02962963 1.07300007.17777777 1.5080001.5333333.17400001.14814814.31900002.29629628.43500003.47407405-.75400005.47407404-1.16000008 1.15555548-1.10200007 2.07407394.116.88888884.60900004 1.4814814 1.39200009 1.89629618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M13.52900093 1.83703692v.4148148c-.058.6518518-.40600002 1.12592585-.87000005 1.54074064-.23200002.17777777-.46400003.3259259-.75400005.38518516-.058 0-.14500001.02962963-.20300001.02962963h-.20300002c-.029-.14814814-.029-.29629628 0-.41481479.14500001-.79999995.58000004-1.3925925 1.27600009-1.74814804.23200001-.11851851.46400002-.17777777.72500004-.2074074h.029z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAppstoreSmall);
export default __webpack_public_path__ + "static/media/btn-appstore-small.891aaaeb57ae8ca8ff9971ddc54d07dc.svg";
export { ForwardRef as ReactComponent };